/*
 * The two roles an account can have, exactly as stanic-api spells them
 * (pkg/enums/UserRole). A reader may read everything this console shows and change
 * nothing — there is no third role, and no per-module permission: the console has one
 * thing worth protecting, which is what the fleet is told about itself.
 */
export enum UserRole {
    Admin  = 'admin',
    Reader = 'reader',
}
